<button
	#popoverTrigger="mtxPopoverTrigger"
	(click)="setSettings()"
	[mtxPopoverTriggerFor]="notificationsPopover"
	class="primary-text"
	mat-menu-item
	mtxPopoverTriggerOn="click"
>
	<span>Notifications</span>
</button>

<mtx-popover
	#notificationsPopover="mtxPopover"
	[closeOnPanelClick]="false"
	class="notifications-margin-top"
>
	<mat-card class="p-0 primary-border">
		<mat-card-content class="notifications-dropdown font-size-14 padding-0-5 m-b-0">
			<div
				class="font-size-18 primary-text font-weight-bold"
				fxLayout="row"
				fxLayoutAlign="start center"
			>
				Notifications
			</div>

			<div *ngIf="!isModelInitialized" class="m-t-1">
				<app-default-progress-bar></app-default-progress-bar>
			</div>

			<mat-accordion
				*ngIf="
					IS_NOT_NULL_OR_UNDEFINED(notificationSettingsModel) &&
					isModelInitialized &&
					(utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper())
				"
				class="full-width"
				multi
			>
				<mat-expansion-panel *ngIf="isBookingAssistant()" class="m-t-1" #baPanel>
					<mat-expansion-panel-header>
						<mat-panel-title> Booking Assistant</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="p-1 p-t-0">
						<div
							*ngIf="notificationSettingsModel.BA_BID_COUNTER"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Counter Received</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BID_COUNTER.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.BA_BID_ACCEPTED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Offer Accepted</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BID_ACCEPTED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<!--		CN-3595 Bid Declined is disabled temporarily until the feature is required again-->
						<!--						<div-->
						<!--							*ngIf="notificationSettingsModel.BA_BID_DECLINE"-->
						<!--							class="m-t-1"-->
						<!--							fxLayout="row"-->
						<!--							fxLayoutGap="1rem"-->
						<!--						>-->
						<!--							<div class="primary-text" fxFlex="30">Offer Declined</div>-->
						<!--							<div class="primary-text" fxFlex>-->
						<!--								<mat-radio-group-->
						<!--									[(ngModel)]="notificationSettingsModel.BA_BID_DECLINE.value"-->
						<!--									class="full-width"-->
						<!--									fxLayoutAlign="space-between center"-->
						<!--								>-->
						<!--									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>-->
						<!--									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>-->
						<!--									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>-->
						<!--									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>-->
						<!--								</mat-radio-group>-->
						<!--							</div>-->
						<!--						</div>-->

						<div
							*ngIf="notificationSettingsModel.BA_BOOKING_CONFIRMATION"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Load Booked</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BOOKING_CONFIRMATION.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.BA_LOAD_CANCEL"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Load Cancel</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_LOAD_CANCEL.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.BA_BOOKING_CONFIRMED_BROKER"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Booking Confirmation</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BOOKING_CONFIRMED_BROKER.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.BA_BOOKING_SIGNATURE_BROKER"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Booking Signature</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BOOKING_SIGNATURE_BROKER.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.MULTIPLE_BIDDING"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Multiple Bidding</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.MULTIPLE_BIDDING.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="
								environment.FEATURE_FLAGS.BA_LOAD_OWNER_UPDATE_BROKER_SETTING_EDITABLE &&
								notificationSettingsModel.BA_LOAD_OWNER_UPDATE
							"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Carrier Load Updates</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_LOAD_OWNER_UPDATE.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP" disabled
										>Desktop</mat-radio-button
									>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE" disabled>None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</mat-expansion-panel>

				<mat-expansion-panel *ngIf="productsService.PROJECT_CARRIERS" class="m-t-1" #projectsPanel>
					<mat-expansion-panel-header>
						<mat-panel-title> Projects</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="p-1 p-t-0">
						<div
							*ngIf="notificationSettingsModel.PROJECT_OWNER"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Assigned Project</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.PROJECT_OWNER.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.RFP_CARRIER_NOT_AVAILABLE"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">RFP Carrier Not Available</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.RFP_CARRIER_NOT_AVAILABLE.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.PROJECT_BEST_RATE_UPDATED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Project Best Rate Updated</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.PROJECT_BEST_RATE_UPDATED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.PROJECT_RATE_RECEIVED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Project Rate Received</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.PROJECT_RATE_RECEIVED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.PROJECT_CARRIER_PROCURED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Project Carrier Procured</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.PROJECT_CARRIER_PROCURED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.CHECK_PROJECT"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Check Project</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.CHECK_PROJECT.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</mat-expansion-panel>

				<mat-expansion-panel *ngIf="productsService.TASKS" class="m-t-1">
					<mat-expansion-panel-header>
						<mat-panel-title> Tasks</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="p-1 p-t-0">
						<div
							*ngIf="notificationSettingsModel.TASK_ASSIGNED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Assigned Task</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.TASK_ASSIGNED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</mat-expansion-panel>

				<mat-expansion-panel class="m-t-1" #carriersPanel>
					<mat-expansion-panel-header>
						<mat-panel-title> Carriers</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="p-1 p-t-0">
						<div
							*ngIf="notificationSettingsModel.USER_ASSIGNED_TO_CARRIER"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Assigned Carrier</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.USER_ASSIGNED_TO_CARRIER.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.CARRIER_EXCLUDED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Carrier Excluded</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.CARRIER_EXCLUDED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>

						<div
							*ngIf="notificationSettingsModel.CARRIER_ONBOARDING_REQUESTED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Carrier Onboarding Requested</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.CARRIER_ONBOARDING_REQUESTED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP" disabled
										>Desktop</mat-radio-button
									>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE" disabled>None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</mat-expansion-panel>

				<mat-expansion-panel class="m-t-1" #loadsPanel>
					<mat-expansion-panel-header>
						<mat-panel-title>Loads</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="p-1 p-t-0">
						<div
							*ngIf="notificationSettingsModel.LOAD_FILE_RECEIVED"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Import File Received</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.LOAD_FILE_RECEIVED.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

			<div
				*ngIf="
					IS_NOT_NULL_OR_UNDEFINED(notificationSettingsModel) &&
					isModelInitialized &&
					utilService.isAccountTypeCarrier()
				"
			>
				<h4>&nbsp;</h4>

				<mat-expansion-panel class="m-t-1" #baPanel>
					<mat-expansion-panel-header>
						<mat-panel-title> Offers </mat-panel-title>
					</mat-expansion-panel-header>

					<div class="p-1 p-t-0">
						<div
							*ngIf="notificationSettingsModel.BA_BID_SELECT"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Offer Accepted</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BID_SELECT.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
						<div
							*ngIf="notificationSettingsModel.BA_BROKER_BID_COUNTER"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">Counter Received</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BROKER_BID_COUNTER.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
						<div
							*ngIf="notificationSettingsModel.BA_BID_INVITE"
							class="m-t-1"
							fxLayout="row"
							fxLayoutGap="1rem"
						>
							<div class="primary-text" fxFlex="30">New Load available</div>
							<div class="primary-text" fxFlex>
								<mat-radio-group
									[(ngModel)]="notificationSettingsModel.BA_BID_INVITE.value"
									class="full-width"
									fxLayoutAlign="space-between center"
								>
									<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
									<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
									<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
									<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</mat-expansion-panel>

				<div
					*ngIf="notificationSettingsModel.NEW_BROKER_CONNECTED"
					fxLayout="row"
					fxLayoutGap="1rem"
					class="m-t-1"
				>
					<div class="primary-text" fxFlex="30">New broker connected to network</div>
					<div class="primary-text" fxFlex>
						<mat-radio-group
							[(ngModel)]="notificationSettingsModel.NEW_BROKER_CONNECTED.value"
							class="full-width"
							fxLayoutAlign="space-between center"
						>
							<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
							<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
							<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
							<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>

				<!-- <div
					*ngIf="notificationSettingsModel.EMAIL_MAPPED_CARRIER"
					fxLayout="row"
					fxLayoutGap="1rem"
				>
					<div class="primary-text" fxFlex="30">Network Expanded</div>
					<div class="primary-text" fxFlex>
						<mat-radio-group
							[(ngModel)]="notificationSettingsModel.EMAIL_MAPPED_CARRIER.value"
							class="full-width"
							fxLayoutAlign="space-between center"
						>
							<mat-radio-button color="primary" value="EMAIL">Email</mat-radio-button>
							<mat-radio-button color="primary" value="DESKTOP">Desktop</mat-radio-button>
							<mat-radio-button color="primary" value="BOTH">Both</mat-radio-button>
							<mat-radio-button color="primary" value="NONE">None</mat-radio-button>
						</mat-radio-group>
					</div>
				</div> -->
			</div>
		</mat-card-content>

		<mat-dialog-actions>
			<div class="padding-0-5 full-width" fxLayoutAlign="end center" fxLayoutGap="2rem">
				<span (click)="closeNotificationPopover()" class="link">Close</span>
				<button
					(click)="updateUserNotificationSettings()"
					*ngIf="!isRequestInProgress"
					class="focused-button"
					color="primary"
					mat-raised-button
				>
					Update
				</button>
				<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
			</div>
		</mat-dialog-actions>
	</mat-card>
</mtx-popover>
